<template>
    <div style="min-height:calc(100vh - 5rem)" class="tw-block tw-relative">

        <!-- <div class="tw-absolute tw-left-0 tw-top-0 tw-h-full tw-w-full tw-flex">
            <div ref="slider" class="tw-h-full tw-w-full">
                <img class="tw-h-full tw-w-full tw-object-cover" :src="image" v-for="image in sliderImages" alt="">
            </div>
        </div>
         -->


        <div class="tw-relative tw-z-10 md:tw-pl-16 md:tw-py-6 tw-flex">
            <div class="tw-bg-white tw-bg-opacity-50 tw-shadow-xl md:tw-rounded-xl w-full md:tw-max-w-128 tw-p-5" style="backdrop-filter: blur(10px)">
                <div class="tw-grid tw-gap-1">
                    <div class="tw-text-xl tw-text-center tw-text-black tw-font-semibold">{{ $word.join_matchmarry }}</div>
                    <div class="tw--mt-3">
                        <div class="tw-mb-1 tw-font-bold">{{$word.i_am}}:</div>
                        <div class="tw-grid tw-grid-cols-2 tw-gap-2">
                            <button class="tw-block filter-button" :class="{'--active' : filters.genders.iAm === 'man'}" v-on:click="filters.genders.iAm = 'man'">
                                <i class="bx bx-male"></i>
                                <span>{{$word.man}}</span>
                            </button>
                            <button class="tw-ml-1 filter-button" :class="{'--active' : filters.genders.iAm === 'woman'}" v-on:click="filters.genders.iAm = 'woman'">
                                <i class="bx bx-female"></i>
                                <span>{{$word.woman}}</span>
                            </button>
                        </div>
                    </div>

                    <div>
                        <div class="tw-mb-1 tw-font-bold">{{$word.looking_for}}:</div>
                        <div class="tw-grid tw-grid-cols-2 tw-gap-2">
                            <button class="tw-block filter-button" :class="{'--active' : filters.genders.lookingFor === 'man'}" v-on:click="filters.genders.lookingFor = 'man'">
                                <i class="bx bx-male"></i>
                                <span>{{$word.man}}</span>
                            </button>
                            <button class="tw-ml-1 filter-button" :class="{'--active' : filters.genders.lookingFor === 'woman'}" v-on:click="filters.genders.lookingFor = 'woman'">
                                <i class="bx bx-female"></i>
                                <span>{{$word.woman}}</span>
                            </button>
                        </div>
                    </div>

                    <div>
                        <div class="tw-mb-1 tw-font-bold">{{$word.ages}}:</div>
                        <div class="tw-flex tw-items-center tw-space-x-2">
                            <select class="tw-flex-1 tw-rounded tw-border tw-border-solid tw-border-gray-200 tw-p-2" v-model="filters.startAge">
                                <option :value="age" v-for="age in ages">{{age}}</option>
                            </select>
                            <div class="tw-font-bold">—</div>
                            <select class="tw-flex-1 tw-rounded tw-border tw-border-solid tw-border-gray-200 tw-p-2" v-model="filters.endAge">
                                <option :value="age" v-for="age in ages">{{age}}</option>
                            </select>
                        </div>
                    </div>

                    <div>
                        <div class="tw-mb-1 tw-font-bold">{{$word.countries}}:</div>
                        <div>
                            <v-select-favorite-countries direction="top" v-model="filters.favoriteCountries"/>
                        </div>
                    </div>

                    <div class="tw-text-xs tw-text-black">
                        {{ $text.confirm_terms_and_conditions }}
                        <a target="_blank" class="rules-link" href="/terms-and-conditions">{{$word.terms_and_conditions }}</a>
                        {{ $text.read_privacy_policy }}
                        <a target="_blank" class="rules-link" href="/privacy-policy">{{ $word.privacy_policy }}</a>
                        {{ $text.understood_privacy_policy }}
                    </div>
                    <div>
                        <button v-on:click.prevent="openRegisterModal" class="tw-w-full tw-bg-primary-500 tw-py-2 tw-px-4 tw-block tw-text-2xl tw-font-bold tw-text-white tw-rounded-xl tw-text-center tw-border-none">{{ $word.find_partner }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: v => ({
            ages: [18, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 80],
            filters: {
                genders: {
                    iAm: "man",
                    lookingFor: "woman"
                },
                startAge: 18,
                endAge: 18,
                favoriteCountries: [],
            }
        }),
        props: {
            // images: {},
            lang: {},
        },
        // computed: {
        //     sliderImages() {
        //         return this.images.map(item => {
        //             let parsed = JSON.parse(item);
        //             return _.get(parsed, this.lang, parsed.en);
        //         })
        //     }
        // },
        // mounted() {
        //     window.slider = tns({
        //         container: this.$refs.slider,
        //         slideBy: 'page',
        //         autoplay: true,
        //         mode: 'gallery',
        //         controls: false,
        //         nav: false,
        //         autoplayButtonOutput: false,
        //         autoHeight: true,
        //     });
        // },
        methods: {
            openRegisterModal() {
                // $dispatch('open-register',this.filters)
                $dispatch('open-register', {
                    genders: this.filters.genders,
                    startAge: this.filters.startAge,
                    endAge: this.filters.endAge,
                    countries: this.filters.favoriteCountries
                })
            }
        }
    }
</script>
<style>
    .tns-inner {
        @apply tw-h-full;
    }
</style>
